import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import axios from "axios";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  Paper,
  Divider,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  Button,
  Drawer,
  ListItemIcon,
  MenuItem,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Fade,
  Stack,
  Select,
  IconButton,
  AppBar,
  Toolbar,
  Slide,
  InputLabel,
  CssBaseline,
  ToggleButtonGroup,
  ToggleButton,
  Link,
  CircularProgress,
  Menu,
  TextField,
  InputAdornment,
  SvgIcon,
  Skeleton,
  Breadcrumbs,
} from "@mui/material";
import {
  AttachMoney,
  Category,
  Business,
  TrendingUp,
  TrendingDown,
  Remove,
  PieChart,
  Close as CloseIcon,
  CloudUpload,
  Dashboard,
  FileDownload,
  CheckCircle,
  RadioButtonUnchecked,
  AccessTime,
  AutoAwesome,
  Campaign,
  Delete,
  ArrowDropDown,
  ArrowDropDownCircle,
  PriceCheck,
  CreditScore,
  CurrencyExchange,
  Info,
  Groups,
  PersonSearch,
  HelpOutline,
  Speed,
  PanToolAlt,
  TrendingFlat,
  PeopleAltOutlined,
  CampaignOutlined,
  FiberManualRecord,
  AccessTimeFilledOutlined,
  AccessTimeFilled,
  Co2,
  EnergySavingsLeaf,
  Insights,
  InsightsOutlined,
  ArrowUpward,
  ArrowDownward,
  HorizontalRule,
  TrendingUpOutlined,
  TrendingDownOutlined,
  TrendingFlatOutlined,
  FilterCenterFocus,
  TipsAndUpdates,
  NavigateNext,
  ReportProblem,
  PlayArrow,
} from "@mui/icons-material";
import { useDropzone } from "react-dropzone";
import FolderIcon from "@mui/icons-material/Folder";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  LabelList,
  Cell,
  Label,
  Text,
  LineChart,
  Legend,
  Line,
  ComposedChart,
  Treemap,
  Rectangle,
  ScatterChart,
  Scatter,
  ZAxis,
  ReferenceLine,
  ReferenceArea,
} from "recharts";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Tooltip as MUITooltip } from "@mui/material";
import { styled } from "@mui/system";
// import { TrendingDown, Minus, PieChart, ChevronDown ,X} from 'lucide-react';
import { TypeAnimation } from "react-type-animation";
import bggenai from "../../assets/bggenai.png";
import bgsd from "../../assets/bgsd.png";
import ailoader from "../../assets/ailoader.gif";
import bgSS from "../../assets/bgSS.png";
import { DeleteIcon, Search } from "lucide-react";
import { IoIosLocate } from "react-icons/io";
import { FaHome, FaUpload, FaChartBar, FaBars } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
// import { withTranslation } from "react-google-multi-lang";
// import { translateBulk } from "./translationService";
import { TbTopologyStar3 } from "react-icons/tb";
import { HeatmapChart } from "./HeatmapChart";
import { useFileContext } from "./FileContext";
import { useDashboardUiState } from "./dashboardUiState";

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  color: "white",
  "&.Mui-selected": {
    backgroundColor: "#BE3FF5",
    color: "white",
    "&:hover": {
      backgroundColor: "#BE3FF5",
    },
  },
}));

export const HistogramChart = ({
  chartData,
  categoryChartDataL1,
  spendSummary,
  roleTitle,
  heatmapChartData,
}) => {
  const fileContext = useFileContext();
  const filenameKey = fileContext?.filename ?? "global";

  const [dataSource, setDataSource] = useDashboardUiState(
    `rapidInsights:${filenameKey}:histogramChart:dataSource`,
    "chartData"
  );
  const [selectedCategory, setSelectedCategory] = useDashboardUiState(
    `rapidInsights:${filenameKey}:histogramChart:selectedCategory`,
    ""
  );

  useEffect(() => {
    if (roleTitle !== "Category Manager") return;
    if (selectedCategory) return;
    if (!chartData || Object.keys(chartData).length === 0) return;

    setSelectedCategory(Object.keys(chartData)[0]);
  }, [chartData, roleTitle, selectedCategory, setSelectedCategory]);
  const LoadingGif = () => (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "50px",
      }}
    >
      <img
        src={ailoader}
        alt="Loading..."
        style={{ width: "30px", height: "30px" }}
      />
    </Box>
  );

  console.log("chartData", chartData);
  console.log("categoryChartDataL1", categoryChartDataL1);

  if (
    !chartData ||
    Object.keys(chartData).length === 0 ||
    !categoryChartDataL1 ||
    categoryChartDataL1.length === 0
  ) {
    return (
      <div>
        <LoadingGif />
      </div>
    );
  }
  const handleChange = (event, newDataSource) => {
    if (newDataSource !== null) {
      setDataSource(newDataSource);
    }
  };
  // Process data to format labels
  const processLabels = (data) => {
    return data.map((entry) => {
      // First try to match strings with numbers
      const numberMatch = entry.name.match(/(\d+)(\D+)/);

      if (numberMatch) {
        const formattedName =
          numberMatch[2].charAt(0).toUpperCase() +
          numberMatch[2].slice(1).replace(/ & /g, "\n&\n");
        return {
          ...entry,
          name: `${formattedName}\n(${numberMatch[1]})`,
        };
      }
      // If no number match, just format the string directly
      else {
        return {
          ...entry,
          name: entry.name.replace(/ & /g, "\n&\n"),
        };
      }
    });
  };


  // Get the appropriate data based on selected source
  const getCurrentData = () => {
    if (dataSource === "chartData" && roleTitle==="Category Manager") {
      return chartData[selectedCategory]?.chart_data || [];
    }
    else if (dataSource === "chartData") {
      return chartData?.category_chart || [];
    }
    return categoryChartDataL1?.category_chart_l1 || [];
  };
  
  // Process and filter the data with safety check
  const filteredData = getCurrentData().length > 0 
    ? processLabels(getCurrentData().filter((entry) => entry.name !== "Total"))
    : [];

  const totalValue = filteredData.reduce((sum, entry) => sum + entry.value, 0);

  const formatPercentage = (value) => {
    return ((value / totalValue) * 100).toFixed(0) + "%";
  };

  const formatLargeNumber = (number) => {
    if (number >= 1e9) {
      return Math.round(number / 1e9) + "B"; // Billions
    } else if (number >= 1e6) {
      return Math.round(number / 1e6) + "M"; // Millions
    } else if (number >= 1e3) {
      return Math.round(number / 1e3) + "K"; // Thousands
    } else {
      return number.toString(); // Smaller numbers
    }
  };

  // Add the number of suppliers to the "Others" label
  const othersEntry = filteredData.find((entry) => entry.name === "Others");
  if (othersEntry) {
    othersEntry.name = `Others (${othersEntry.numCategories} categories)`;
  }

  // Use the top5percentage from the respective data source
  const getTop5Percentage = () => {
    return dataSource === "chartData"
      ? chartData[selectedCategory].top5percentage
      : categoryChartDataL1.top5percentagel1;
  };

  const extractNumericValue = (value) => {
    // Remove any currency symbols and commas, then convert to number
    return Number(value.replace(/[$£€A¥]|,/g, ""));
  };

  // Inside the HistogramChart component:
  const getCurrencySymbol = (currency) => {
    switch (currency) {
      case "USD":
        return "$";
      case "EUR":
        return "€";
      case "GBP":
        return "£";
      case "AUD":
        return "A$";
      default:
        return currency;
    }
  };

  // Get the currency symbol from spendSummary
  const currencySymbol = getCurrencySymbol(
    spendSummary.spend_summary.currency_value
  );

  // Convert client revenue to numeric value
  // const numericRevenue = extractNumericValue(clientRevenue);

  const allCategoriesSame = Object.values(chartData).every(
    (data, _, arr) => JSON.stringify(data) === JSON.stringify(arr[0])
  );
  

  const getHeatmapColor = (value) => {
    if (value > 20) return "#1a9850";
    if (value > 10) return "#91cf60";
    if (value > 0) return "#d9ef8b";
    if (value > -10) return "#fee08b";
    if (value > -20) return "#fc8d59";
    return "#d73027";
  };


  return (
    <div
      style={{
        // border: "1px solid #FFFFFF0F",
        // borderRadius: "12px",
        // padding: "1rem",
        // marginBottom:"5rem",
      }}
    >

      {roleTitle==="Category Manager" && (
        <>
 <Box display="flex" justifyContent="center" mb={2}>
  {!allCategoriesSame && (
    <ToggleButtonGroup
      value={selectedCategory}
      exclusive
      onChange={(event, newValue) => {
        if (newValue !== null) {
          setSelectedCategory(newValue);
        }
      }}
      aria-label="category selection"
      sx={{ gap: "6px" }}
    >
      {Object.keys(chartData).map((category) => (
        <StyledToggleButton
          key={category}
          value={category}
          aria-label={category}
          sx={{
            border: "1px solid transparent",
            borderRadius: "4px",
            padding: "6px 12px",
            minWidth: "fit-content",
            height: "32px",
          }}
        >
          <span style={{ 
            fontStyle: "Roboto", 
            fontWeight: 300, 
            fontSize: "12px",
            whiteSpace: "nowrap"
          }}>
            {category}
          </span>
        </StyledToggleButton>
      ))}
    </ToggleButtonGroup>
  )}
</Box>
      <Box
        sx={{
          position: "relative",
          top: 20,
          left: 700,
          width: "330px",
          height: "auto",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          borderRadius: "8px",
          padding: "8px",
          color: "white",
          fontStyle: "Roboto",
          fontSize: "12px",
          textAlign: "left",
          boxShadow: "3px 3px 5px rgba(0, 0, 0, 0.2)",
          zIndex: 1,
          marginBottom: "2rem",
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            textAlign: "left",
          }}
        >
          <Insights
            sx={{ mr: 0.5, verticalAlign: "middle", fontSize: "20px" }}
          />
  Top {filteredData.filter(item => !item.name.includes('others') && !item.isTotal).length} {chartData?.[Object.keys(chartData)[0]]?.l2_flag===1? "L2":"L3"} categories cover {getTop5Percentage().toFixed(0)}% of the spend
        </Typography>
        {/* You can add more details here if needed */}
      </Box>
      <ResponsiveContainer
        width="100%"
        height={400}
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <BarChart
          data={filteredData}
          margin={{ top: 20, right: 30, left: 40, bottom: 25 }}
        >
          <defs>
            <linearGradient id="colorGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#BF6FE5" stopOpacity={1} />
              <stop offset="100%" stopColor="#CA698F" stopOpacity={1} />
            </linearGradient>
          </defs>
          <XAxis
            dataKey="name"
            tick={{
              fill: "white",
              fontWeight: 400,
              fontSize: "12px",
              fontStyle: "Roboto",
            }}
            interval={0} // Show all labels
          >
            <Label
              value="Categories"
              position="bottom"
              offset={10}
              style={{
                textAnchor: "middle",
                fill: "white",
                fontWeight: 400,
                fontSize: "12px",
                fontStyle: "Roboto",
              }}
            />
          </XAxis>
          <YAxis
            tick={{
              fill: "white",
              fontWeight: 400,
              fontSize: "12px",
              fontStyle: "Roboto",
            }}
            tickFormatter={formatLargeNumber}
          >
            <Label
              value={`Spend (in ${
                spendSummary.spend_summary.currency_value === "EUR"
                  ? "€"
                  : spendSummary.spend_summary.currency_value === "USD"
                  ? "$"
                  : spendSummary.spend_summary.currency_value === "GBP"
                  ? "£"
                  : spendSummary.spend_summary.currency_value === "AUD"
                  ? "A$"
                  : spendSummary.spend_summary.currency_value
              })`}
              angle={-90}
              position="insideLeft"
              style={{
                fill: "white",
                fontWeight: 400,
                fontSize: "12px",
                fontStyle: "Roboto",
              }}
              offset={-20}
            />
          </YAxis>
          <Tooltip
            content={({ active, payload }) => {
              if (
                active &&
                payload &&
                payload.length &&
                (dataSource === "chartData" )
              ) {
                const categorySpend = payload[0].value;
                const totalSpend = filteredData.reduce(
                  (sum, entry) => sum + entry.value,
                  0
                );
                const percentage = ((categorySpend / totalSpend) * 100).toFixed(
                  2
                );

                return (
                  <Box
                    sx={{
                      backgroundColor: "#FFFFFF0F",
                      padding: "10px",
                      borderRadius: "6px",
                    }}
                  >
                    {/* Progress bar */}
                    <Box
                      sx={{
                        width: "100%",
                        height: "8px",
                        backgroundColor: "#4E4E4E",
                        borderRadius: "2px",
                        mb: 2,
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <Box
                        sx={{
                          position: "absolute",
                          left: 0,
                          top: 0,
                          height: "100%",
                          width: `${percentage}%`,
                          background:
                            "linear-gradient(180deg, #BF6FE5 0%, #CA698F 100%)",
                          borderRadius: "4px",
                        }}
                      />
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                      <Box
                        sx={{
                          width: "12px",
                          height: "12px",
                          backgroundColor: "#4E4E4E",
                          mr: 1,
                          borderRadius: "2px",
                        }}
                      />
                      <Typography
                        sx={{
                          color: "#FFFFFF",
                          fontSize: "12px",
                          fontStyle: "Roboto",
                          fontWeight: 500,
                        }}
                      >
                        Total Spend ({currencySymbol}
                        {formatLargeNumber(totalSpend)})
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        sx={{
                          width: "12px",
                          height: "12px",
                          background:
                            "linear-gradient(180deg, #BF6FE5 0%, #CA698F 100%)",
                          mr: 1,
                          borderRadius: "2px",
                        }}
                      />
                      <Typography
                        sx={{
                          color: "#FFFFFF",
                          fontSize: "12px",
                          fontStyle: "Roboto",
                          fontWeight: 500,
                        }}
                      >
                        Spend as % of total spend ({Math.round(percentage)}%)
                      </Typography>
                    </Box>
                  </Box>
                );
              }
              return null;
            }}
            cursor={{ fill: "transparent", cursor: "pointer" }}
            position="top"
            offset={-120}
            wrapperStyle={{ outline: "none" }}
          />
          <Bar
            dataKey="value"
            fill="url(#colorGradient)"
            barSize={80}
            radius={[6, 6, 0, 0]}
            cursor="pointer"
          >
            <LabelList
              dataKey="value"
              position="center"
              formatter={(value) => formatLargeNumber(value)}
              style={{ fill: "white", fontSize: "0.8rem" }}
            />
            <LabelList
              dataKey="value"
              position="top"
              formatter={(value) => formatPercentage(value)}
              style={{ fill: "white", fontSize: "0.8rem" }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      </>
      )}
{roleTitle === "Chief Procurement Officer" && (
  <>
    <Box display="flex" justifyContent="center" mb={2}>
      <ToggleButtonGroup
        value={dataSource}
        exclusive
        onChange={handleChange}
        aria-label="data source"
        sx={{ gap: "6px" }}
      >
        <StyledToggleButton
          value="chartData"
          aria-label="L1 data"
          sx={{
            border: "1px solid transparent",
            borderRadius: "4px",
            height: "15px",
          }}
        >
          <span style={{ font: "Roboto", fontWeight: 600, fontSize: "12px" }}>
            Level 1
          </span>
        </StyledToggleButton>
        <StyledToggleButton
          value="categoryChartDataL1"
          aria-label="L2 data"
          sx={{
            border: "1px solid transparent",
            borderRadius: "4px",
            height: "15px",
          }}
        >
          <span style={{ font: "Roboto", fontWeight: 600, fontSize: "12px" }}>
            Level 2
          </span>
        </StyledToggleButton>
      </ToggleButtonGroup>
    </Box>
    <Box display="flex" flexDirection="column" gap={2}>
      {/* Chart container with relative positioning for overlay */}
      <Box flex={1} position="relative">
        <ResponsiveContainer
          width="100%"
          height={400}
          sx={{
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <BarChart
            data={filteredData}
            margin={{ top: 20, right: 10, left: 5, bottom: 25 }}
          >
            {/* <defs>
              <linearGradient id="colorGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#BE3FF5" stopOpacity={1} />
                <stop offset="100%" stopColor="#BE3FF5" stopOpacity={1} />
              </linearGradient>
            </defs> */}

<defs>
            <linearGradient id="colorGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#BF6FE5" stopOpacity={1} />
              <stop offset="100%" stopColor="#CA698F" stopOpacity={1} />
            </linearGradient>
          </defs>

            <XAxis
              dataKey="name"
              tick={{
                fill: "white",
                fontWeight: 400,
                fontSize: "12px",
                fontStyle: "Roboto",
              }}
              // axisLine={false}
              // tickLine={false}
              // angle={-45}
              // textAnchor="end"
              // height={80}
              >
              <Label
                value="Categories"
                position="bottom"
                offset={10}
                style={{
                  textAnchor: "middle",
                  fill: "white",
                  fontWeight: 400,
                  fontSize: "12px",
                  fontStyle: "Roboto",
                }}
              />
            </XAxis>

            <YAxis
              type="number"
              tick={{
                fill: "white",
                fontWeight: 400,
                fontSize: "12px",
                fontStyle: "Roboto",
              }}
              tickFormatter={formatLargeNumber}
              axisLine={false}
              tickLine={false}
              >
              <Label
                value={`Spend (in ${
                  spendSummary.spend_summary.currency_value === "EUR"
                    ? "€"
                    : spendSummary.spend_summary.currency_value === "USD"
                    ? "$"
                    : spendSummary.spend_summary.currency_value === "GBP"
                    ? "£"
                    : spendSummary.spend_summary.currency_value === "AUD"
                    ? "A$"
                    : spendSummary.spend_summary.currency_value
                })`}
                angle={-90}
                position="insideLeft"
                style={{
                  fill: "white",
                  fontWeight: 400,
                  fontSize: "12px",
                  fontStyle: "Roboto",
                }}
                offset={0}
              />
            </YAxis>
            <Tooltip
            content={({ active, payload }) => {
              if (
                active &&
                payload &&
                payload.length &&
                (dataSource === "chartData" || dataSource === "categoryChartDataL1")
              ) {
                const categorySpend = payload[0].value;
                const totalSpend = filteredData.reduce(
                  (sum, entry) => sum + entry.value,
                  0
                );
                const percentage = ((categorySpend / totalSpend) * 100).toFixed(
                  2
                );

                return (
                  <Box
                    sx={{
                      backgroundColor: "#FFFFFF0F",
                      padding: "10px",
                      borderRadius: "6px",
                    }}
                  >
                    {/* Progress bar */}
                    <Box
                      sx={{
                        width: "100%",
                        height: "8px",
                        backgroundColor: "#4E4E4E",
                        borderRadius: "2px",
                        mb: 2,
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <Box
                        sx={{
                          position: "absolute",
                          left: 0,
                          top: 0,
                          height: "100%",
                          width: `${percentage}%`,
                          background:
                            "linear-gradient(180deg, #BF6FE5 0%, #CA698F 100%)",
                          borderRadius: "4px",
                        }}
                      />
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                      <Box
                        sx={{
                          width: "12px",
                          height: "12px",
                          backgroundColor: "#4E4E4E",
                          mr: 1,
                          borderRadius: "2px",
                        }}
                      />
                      <Typography
                        sx={{
                          color: "#FFFFFF",
                          fontSize: "12px",
                          fontStyle: "Roboto",
                          fontWeight: 500,
                        }}
                      >
                        Total Spend ({currencySymbol}
                        {formatLargeNumber(totalSpend)})
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        sx={{
                          width: "12px",
                          height: "12px",
                          background:
                            "linear-gradient(180deg, #BF6FE5 0%, #CA698F 100%)",
                          mr: 1,
                          borderRadius: "2px",
                        }}
                      />
                      <Typography
                        sx={{
                          color: "#FFFFFF",
                          fontSize: "12px",
                          fontStyle: "Roboto",
                          fontWeight: 500,
                        }}
                      >
                        Spend as % of total spend ({Math.round(percentage)}%)
                      </Typography>
                    </Box>
                  </Box>
                );
              }
              return null;
            }}
            cursor={{ fill: "transparent", cursor: "pointer" }}
            position="top"
            offset={-120}
            wrapperStyle={{ outline: "none" }}
          />

            <Bar
              dataKey="value"
              fill="url(#colorGradient)"
              barSize={80}
              radius={[6, 6, 0, 0]}
              cursor="pointer"
            >
              <LabelList
                dataKey="value"
                position="top"
                formatter={(value) => formatPercentage(value)}
                style={{ fill: "white", fontSize: "0.8rem" }}
              />
              <LabelList
                dataKey="value"
                position="center"
                formatter={(value) => formatLargeNumber(value)}
                
                style={{ fill: "white", fontSize: "0.8rem" }}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
        
        {/* Spend evolution box at top right of the chart */}
        {filteredData.some(item => 
          (item.yoy_change !== undefined && item.yoy_change !== null) || 
          (item.period_change !== undefined && item.period_change !== null)
        ) && (
          <Box
    position="absolute"
    top="-50px"
    right={filteredData.length > 0 && 
           filteredData[filteredData.length - 1].value > 
           filteredData.reduce((sum, item) => sum + item.value, 0) / filteredData.length * 1.5 
           ? "200px" : "10px"}  // Shift left if last bar is too tall
    bgcolor="rgba(255, 255, 255, 0.1)"
    borderRadius="6px"
    padding="8px 12px"
    border="1px solid #BE3FF5"
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: "4px",
      marginBottom: "1rem",
      width: '250px',
      transition: 'right 0.3s ease-in-out'  // Smooth transition for position change
    }}
  >
            <Typography
              variant="caption"
              sx={{
                color: "white",
                fontSize: "10px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {
                filteredData.some(item => item.yoy_change !== undefined && item.yoy_change !== null) 
                  ? "Spend Evolution"
                  : "Spend Evolution"
              }
              {(() => {
                // Access change_period from the parent data object, not from the items
                const timePeriod = dataSource === "chartData" 
                  ? chartData?.change_period 
                  : categoryChartDataL1?.change_period;
                
                return timePeriod ? ` (${timePeriod})` : '';
              })()}
            </Typography>
            
            {/* Display YoY/Period change for all categories (except Total), sorted by absolute value */}
            {(() => {
  // Filter items with valid change values and not marked as total
  const itemsWithChange = filteredData.filter(item => {
    const changeValue = item.yoy_change !== undefined && item.yoy_change !== null 
      ? item.yoy_change
      : item.period_change;
    // Filter out items marked as total and any "Others" category
    return changeValue !== undefined && changeValue !== null && 
           !item.isTotal && 
           !item.name.toLowerCase().includes('others');
  });
  
  // Sort by absolute value (descending)
  const sortedItems = [...itemsWithChange].sort((a, b) => {
    const changeA = a.yoy_change !== undefined && a.yoy_change !== null 
      ? a.yoy_change
      : a.period_change;
    const changeB = b.yoy_change !== undefined && b.yoy_change !== null 
      ? b.yoy_change
      : b.period_change;
    return Math.abs(changeB) - Math.abs(changeA);
  });
  
  // Take only the top 5
  const top5Items = sortedItems.slice(0, 5);
  
  return top5Items.map((item, index) => {
    const changeValue = item.yoy_change !== undefined && item.yoy_change !== null 
      ? item.yoy_change
      : item.period_change;
    
    const colorValue = changeValue > 0 
      ? "#4CAF50"  // green for positive
      : changeValue < 0 
        ? "#F44336"  // red for negative
        : "white";   // white for no change
        
    const directionIcon = changeValue > 0 
      ? "▲" 
      : changeValue < 0 
        ? "▼" 
        :   <PlayArrow
                                                          sx={{
                                                            fontSize: 14,
                                                          }}
                                                        />;
        
    return (
      <Box 
        key={`change-${index}`}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        gap="4px"
      >
        <Typography
          variant="caption"
          sx={{
            color: "white",
            fontSize: "10px",
            maxWidth: "120px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={item.name} // Show full name on hover
        >
          {item.name}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: colorValue,
            fontSize: "10px",
            fontWeight: "bold",
          }}
        >
          {directionIcon} {Math.abs(changeValue).toFixed(0)}%
        </Typography>
      </Box>
    );
  });
})()}
          </Box>
        )}
      </Box>
    </Box>
  </>
)}
    </div>
  );
};
